(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.lux = {}));
})(this, (function (exports) { 'use strict';

  /**
   * 格式化银行卡号
   *
   * @export
   * @param {string} cardNum
   * @returns {string}
   */
  function creditCard(cardNum, mask) {
      var newCardNum = cardNum
          .replace(/\s/g, '')
          .replace(/[^\d]/g, '')
          .replace(/(\d{4})(?=\d)/g, '$1 ');
      return mask ? newCardNum.replace(/\s(\d{4})(?!\d)/g, ' ****') : newCardNum;
  }
  /**
   * 格式化手机号
   *
   * @export
   * @param {string} phoneNum
   * @returns {string}
   */
  function phoneNumber(phoneNum, mask) {
      var newPhoneNum = phoneNum
          .replace(/\s/g, '')
          .replace(/[^\d]/g, '')
          .replace(/(\d{3})(\d{4})(?=\d)/g, '$1 $2 ');
      return mask ? newPhoneNum.replace(/\s(\d{4})\s/g, ' **** ') : newPhoneNum;
  }
  // 格式化身份证号
  function formatIdentity(data) {
      if (!data) {
          return null;
      }
      var cardNum = data.replace(data.slice(2, -3), '*************');
      return cardNum;
  }
  // 格式化名字
  function formatName(data) {
      if (!data) {
          return null;
      }
      if (data.length < 3) {
          return data.slice(0, 1) + '*';
      }
      return data.slice(0, -2) + '**';
  }
  /**
   * 格式化数字，添加千位分隔符
   *
   * @export
   * @param {(string | number)} num
   * @returns {string}
   */
  function number(num) {
      var numStr = String(num);
      var int = numStr.split('.')[0];
      var decimal = numStr.split('.')[1];
      return (int
          .replace(/\s/g, '')
          .replace(/[^\d]/g, '')
          .replace(/(?!^)(?=(\d{3})+$)/g, ',') + (decimal ? '.' + decimal : ''));
  }
  // 格式化小数点
  function formatToFixed(data, point) {
      if (!data)
          return;
      return data.toFixed(point);
  }
  //校验身份证号
  function verifyIdcard(idcard) {
      if (idcard === '') {
          return true;
      }
      var regex1 = /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
      /* 身份号码位数及格式检验 */
      switch (idcard.length) {
          case 15:
              if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 ||
                  ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 &&
                      (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)) {
                  var regex2_1 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; // 测试出生日期的合法性
                  if (regex2_1.test(idcard)) {
                      return true;
                  }
                  return false;
              }
              // eslint-disable-next-line
              var regex2 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; // 测试出生日期的合法性
              if (regex2.test(idcard)) {
                  return true;
              }
              return false;
          case 18:
              if (regex1.test(idcard)) {
                  var S = (parseInt(idcard.charAt(0)) + parseInt(idcard.charAt(10))) * 7 +
                      (parseInt(idcard.charAt(1)) + parseInt(idcard.charAt(11))) * 9 +
                      (parseInt(idcard.charAt(2)) + parseInt(idcard.charAt(12))) * 10 +
                      (parseInt(idcard.charAt(3)) + parseInt(idcard.charAt(13))) * 5 +
                      (parseInt(idcard.charAt(4)) + parseInt(idcard.charAt(14))) * 8 +
                      (parseInt(idcard.charAt(5)) + parseInt(idcard.charAt(15))) * 4 +
                      (parseInt(idcard.charAt(6)) + parseInt(idcard.charAt(16))) * 2 +
                      parseInt(idcard.charAt(7)) * 1 +
                      parseInt(idcard.charAt(8)) * 6 +
                      parseInt(idcard.charAt(9)) * 3;
                  var Y = S % 11;
                  var M = 'F';
                  var JYM = '10X98765432';
                  M = JYM.substr(Y, 1);
                  /* 判断校验位 */
                  if (M === idcard.charAt(17).toUpperCase()) {
                      return true;
                  }
                  return false;
              }
              break;
          default:
              return false;
      }
  }
  // 格式化将数字金额转换成大写中文
  function famatterNumToChinese(moneyString) {
      var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      var cnIntRadice = ['', '拾', '佰', '仟'];
      var cnIntUnits = ['', '万', '亿', '兆'];
      var cnDecUnits = ['角', '分', '毫', '厘'];
      var cnInteger = '整';
      var cnIntLast = '元';
      var maxNum = 999999999999999.9999;
      var IntegerNum;
      var DecimalNum;
      var ChineseStr = '';
      var parts;
      if (moneyString === '') {
          return '';
      }
      var money = parseFloat(moneyString);
      if (money >= maxNum) {
          return '';
      }
      if (money === 0) {
          ChineseStr = cnNums[0] + cnIntLast + cnInteger;
          return ChineseStr;
      }
      money = money.toString();
      if (money.indexOf('.') === -1) {
          IntegerNum = money;
          DecimalNum = '';
      }
      else {
          parts = money.split('.');
          IntegerNum = parts[0];
          DecimalNum = parts[1].substr(0, 4);
      }
      if (parseInt(IntegerNum) > 0) {
          var zeroCount = 0;
          var IntLen = IntegerNum.length;
          for (var index = 0; index < IntLen; index++) {
              var n = IntegerNum.substr(index, 1);
              var p = IntLen - index - 1;
              var q = p / 4;
              var m = p % 4;
              if (n === '0') {
                  zeroCount++;
              }
              else {
                  if (zeroCount > 0) {
                      ChineseStr += cnNums[0];
                  }
                  // 归零
                  zeroCount = 0;
                  ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
              }
              if (m === 0 && zeroCount < 4) {
                  ChineseStr += cnIntUnits[q];
              }
          }
          ChineseStr += cnIntLast;
      }
      if (DecimalNum !== '') {
          var decLen = DecimalNum.length;
          for (var index = 0; index < decLen; index++) {
              var n = DecimalNum.substr(index, 1);
              if (n !== '0') {
                  ChineseStr += cnNums[Number(n)] + cnDecUnits[index];
              }
          }
      }
      if (ChineseStr === '') {
          ChineseStr += cnNums[0] + cnIntLast + cnInteger;
      }
      else if (DecimalNum === '') {
          ChineseStr += cnInteger;
      }
      return ChineseStr;
  }

  var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    creditCard: creditCard,
    phoneNumber: phoneNumber,
    formatIdentity: formatIdentity,
    formatName: formatName,
    number: number,
    formatToFixed: formatToFixed,
    verifyIdcard: verifyIdcard,
    famatterNumToChinese: famatterNumToChinese
  });

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
      return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
  }

  function __generator(thisArg, body) {
      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
      function verb(n) { return function (v) { return step([n, v]); }; }
      function step(op) {
          if (f) throw new TypeError("Generator is already executing.");
          while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                  case 0: case 1: t = op; break;
                  case 4: _.label++; return { value: op[1], done: false };
                  case 5: _.label++; y = op[1]; op = [0]; continue;
                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
                  default:
                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                      if (t[2]) _.ops.pop();
                      _.trys.pop(); continue;
              }
              op = body.call(thisArg, _);
          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
      }
  }

  function __spreadArrays() {
      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
      for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
              r[k] = a[j];
      return r;
  }

  function getQueryParam(url) {
      var search = url.split('?')[1];
      var result = {};
      if (search) {
          var params = search.split('&');
          params.forEach(function (paramString) {
              var param = paramString.split('=');
              var key = param[0];
              var value = decodeURIComponent(param[1]);
              result[key] = value;
          });
      }
      return result;
  }
  /**
   * 解析 URL
   *
   * @export
   * @param {string} url
   * @returns {UrlMeta}
   */
  function parse(url) {
      var parsedUrl = new URL(url);
      var params = getQueryParam(parsedUrl.search);
      return __assign(__assign({}, parsedUrl), { params: params });
  }
  /**
   * 获取 url 中 query 参数
   *
   * @export
   * @param {string} name
   * @returns {string}
   */
  function getSearchParam(name) {
      var params = parse(window.location.href).params;
      return params[name];
  }
  /**
   * json 数据转 url 参数
   *
   * @export
   * @param {Params} params
   * @returns {string}
   */
  function toQueryString(params) {
      return params
          ? Object.keys(params)
              .map(function (key) {
              return key + "=" + encodeURIComponent(params[key].toString());
          })
              .join('&')
          : '';
  }
  /**
   * url 拼接新参数
   *
   * @export
   * @param {string} url
   * @param {Params<any>} params
   * @returns {string}
   */
  function addSearchParam(url, params) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + toQueryString(params);
  }

  var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    parse: parse,
    getSearchParam: getSearchParam,
    toQueryString: toQueryString,
    addSearchParam: addSearchParam
  });

  var rule = {
      string: function (arg) { return typeof arg === 'string'; },
      number: function (arg) { return typeof arg === 'number'; },
      null: function (arg) { return !arg && typeof arg !== 'undefined' && arg !== 0; },
      undefined: function (arg) { return typeof arg === 'undefined'; },
      array: function (arg) { return Array.isArray(arg); },
      object: function (arg) {
          return typeof arg === 'object' &&
              Object.prototype.toString.call(arg) === '[object Object]';
      },
      url: function (url) {
          return /(http|ftp|https|ws|wss):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/.test(url);
      },
      email: function (email) {
          return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(email);
      },
      phone: function (phone) {
          // 2022.2.14 修改手机号规则，前端手机号只做简单校验，11位数字，1开头
          return /^1[3456789]\d{9}$/.test(phone);
      },
      identity: function (id) {
          if (id.length !== 18)
              return false;
          var cityNo = {
              11: '北京',
              12: '天津',
              13: '河北',
              14: '山西',
              15: '内蒙古',
              21: '辽宁',
              22: '吉林',
              23: '黑龙江',
              31: '上海',
              32: '江苏',
              33: '浙江',
              34: '安徽',
              35: '福建',
              36: '江西',
              37: '山东',
              41: '河南',
              42: '湖北',
              43: '湖南',
              44: '广东',
              45: '广西',
              46: '海南',
              50: '重庆',
              51: '四川',
              52: '贵州',
              53: '云南',
              54: '西藏',
              61: '陕西',
              62: '甘肃',
              63: '青海',
              64: '宁夏',
              65: '新疆',
              71: '台湾',
              81: '香港',
              82: '澳门',
              91: '国外'
          };
          var province = id.substr(0, 2);
          if (!cityNo[province])
              return false;
          var regexp = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
          var match = id.match(regexp);
          var year = Number(match[2]);
          var month = Number(match[3]);
          var date = Number(match[4]);
          var birthday = new Date(year, month - 1, date);
          var isValidBirthday = birthday.getFullYear() === year &&
              birthday.getMonth() + 1 === month &&
              birthday.getDate() === date;
          if (!isValidBirthday)
              return false;
          var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
          var cardTemp = 0;
          var valnum;
          for (var i = 0; i < 17; i++) {
              cardTemp += Number(id.substr(i, 1)) * arrInt[i];
          }
          valnum = arrCh[cardTemp % 11];
          if (valnum !== id.substr(17, 1).toLocaleUpperCase())
              return false;
          return true;
      },
      creditCard: function (card) {
          if (!/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/.test(card))
              return false;
          var sum = 0;
          var digit;
          var tmpNum;
          var shouldDouble;
          for (var i = card.length - 1; i >= 0; i--) {
              digit = card.substr(i, 1);
              tmpNum = Number(digit);
              if (shouldDouble) {
                  tmpNum *= 2;
                  if (tmpNum >= 10) {
                      sum += (tmpNum % 10) + 1;
                  }
                  else {
                      sum += tmpNum;
                  }
              }
              else {
                  sum += tmpNum;
              }
              shouldDouble = !shouldDouble;
          }
          return !!(sum % 10 === 0 ? card : false);
      },
      contains: function (arg, value) {
          if (typeof arg === 'string' && typeof value === 'string') {
              return arg.includes(value);
          }
          if (Array.isArray(arg)) {
              return arg.includes(value);
          }
          if (rule.object(arg) && typeof value === 'string') {
              return Object.keys(arg).includes(value);
          }
      },
      empty: function (arg) {
          if (rule.string(arg))
              return arg === '';
          if (rule.array(arg))
              return arg.length === 0;
          if (rule.object(arg))
              return Object.keys(arg).length === 0;
          if (rule.undefined(arg) || rule.null(arg))
              return true;
          return false;
      },
      not: function (arg1, arg2) { return arg1 !== arg2; },
      eq: function (arg1, arg2) { return arg1 === arg2; },
      gt: function (arg1, arg2) {
          return Number(arg1) > Number(arg2);
      },
      gte: function (arg1, arg2) {
          return Number(arg1) >= Number(arg2);
      },
      lt: function (arg1, arg2) {
          return Number(arg1) < Number(arg2);
      },
      lte: function (arg1, arg2) {
          return Number(arg1) <= Number(arg2);
      },
      //校验身份证号是否合规
      verifyIdcard: function (idcard) {
          if (idcard === '') {
              return true;
          }
          var regex1 = /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
          /* 身份号码位数及格式检验 */
          switch (idcard.length) {
              case 15:
                  if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 ||
                      ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 &&
                          (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)) {
                      var regex2_1 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; // 测试出生日期的合法性
                      if (regex2_1.test(idcard)) {
                          return true;
                      }
                      return false;
                  }
                  // eslint-disable-next-line
                  var regex2 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; // 测试出生日期的合法性
                  if (regex2.test(idcard)) {
                      return true;
                  }
                  return false;
              case 18:
                  if (regex1.test(idcard)) {
                      var S = (parseInt(idcard.charAt(0)) + parseInt(idcard.charAt(10))) * 7 +
                          (parseInt(idcard.charAt(1)) + parseInt(idcard.charAt(11))) * 9 +
                          (parseInt(idcard.charAt(2)) + parseInt(idcard.charAt(12))) * 10 +
                          (parseInt(idcard.charAt(3)) + parseInt(idcard.charAt(13))) * 5 +
                          (parseInt(idcard.charAt(4)) + parseInt(idcard.charAt(14))) * 8 +
                          (parseInt(idcard.charAt(5)) + parseInt(idcard.charAt(15))) * 4 +
                          (parseInt(idcard.charAt(6)) + parseInt(idcard.charAt(16))) * 2 +
                          parseInt(idcard.charAt(7)) * 1 +
                          parseInt(idcard.charAt(8)) * 6 +
                          parseInt(idcard.charAt(9)) * 3;
                      var Y = S % 11;
                      var M = 'F';
                      var JYM = '10X98765432';
                      M = JYM.substr(Y, 1);
                      /* 判断校验位 */
                      if (M === idcard.charAt(17).toUpperCase()) {
                          return true;
                      }
                      return false;
                  }
                  break;
              default:
                  return false;
          }
      }
  };

  var Validator = /** @class */ (function () {
      function Validator(value) {
          this.value = value;
          this.passed = true;
          this.message = 'passed';
      }
      Validator.prototype.data = function (value) {
          this.value = value;
          return this;
      };
      Validator.prototype.required = function (message, callback) {
          if (!this.passed)
              return this;
          if (!this.value) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.minLength = function (length, message, callback) {
          if (!this.passed)
              return this;
          if (rule.lt(this.value.toString().length, length)) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.maxLength = function (length, message, callback) {
          if (!this.passed)
              return this;
          if (rule.gt(this.value.toString().length, length)) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.equals = function (data, message, callback) {
          if (!this.passed)
              return this;
          if (rule.not(this.value, data)) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.range = function (range, message, callback) {
          if (!this.passed)
              return this;
          if (rule.lt(this.value, range[0]) || rule.gt(this.value, range[1])) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.regexp = function (reg, message, callback) {
          if (!this.passed)
              return this;
          if (!reg.test(this.value.toString())) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.phone = function (message, callback) {
          if (!this.passed)
              return this;
          if (!rule.phone(this.value.toString())) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.identity = function (message, callback) {
          if (!this.passed)
              return this;
          if (!rule.identity(this.value.toString())) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.contains = function (value, message, callback) {
          if (!this.passed)
              return this;
          if (!rule.contains(this.value, value)) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.lte = function (value, message, callback) {
          if (!this.passed)
              return this;
          if (!rule.lte(this.value, value)) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.lt = function (value, message, callback) {
          if (!this.passed)
              return this;
          if (!rule.lt(this.value, value)) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.gte = function (value, message, callback) {
          if (!this.passed)
              return this;
          if (!rule.gte(this.value, value)) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.gt = function (value, message, callback) {
          if (!this.passed)
              return this;
          if (!rule.gt(this.value, value)) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      Validator.prototype.exec = function (method, message, params, callback) {
          if (params === void 0) { params = []; }
          if (!this.passed)
              return this;
          var result = method.apply(void 0, __spreadArrays([this.value], params));
          if (!result) {
              this.message = message;
              this.passed = false;
          }
          callback && callback(this);
          return this;
      };
      return Validator;
  }());

  var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': Validator
  });

  function getOS() {
      var ua = navigator.userAgent;
      var os = {
          name: 'unknown',
          version: 'unknown'
      };
      if (ua.includes('Android') || ua.includes('Adr')) {
          os.name = 'android';
          os.version = ua.match(/Android ([\w.]+)/)[1];
      }
      else if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          os.name = 'ios';
          if (ua.includes('iPad')) {
              os.version = ua.match(/CPU OS ([\w_]+)/)[1].replace('_', '.');
          }
          else {
              os.version = ua.match(/iPhone OS ([\w_]+)/)[1].replace('_', '.');
          }
      }
      else if (ua.includes('mac os x')) {
          os.name = 'mac';
          os.version = ua.match(/Mac OS X ([\w_]+)/)[1].replace('_', '.');
      }
      else if (ua.includes('Windows NT')) {
          os.name = 'windows';
          os.version = ua.match(/Windows NT ([\w_]+)/)[1];
      }
      return os;
  }
  function judgeBrand() {
      var ua = navigator.userAgent.toLowerCase();
      var isHuawei = ua.includes('huawei');
      var isHonor = ua.includes('honor');
      var isOppo = ua.includes('oppo');
      var isOppoR15 = ua.includes('pacm00');
      var isRno4 = ua.includes('pdpm00');
      var isRno3 = ua.includes('pclm50');
      var isVivo = ua.includes('vivo');
      var isVivo3 = ua.includes('v1938ct');
      var isXiaomi = ua.includes('mi');
      var isXiaomi2s = ua.includes('mix');
      var isRedmi = ua.includes('redmi');
      var isSamsung = ua.includes('sm-');
      var isMz = ua.includes('mz');
      var isMeizu = ua.includes('mzb');
      var isMeizuqq = ua.includes('mqqb');
      var isMx = ua.includes('mx');
      var isMzNote = ua.includes('m1822');
      if (isHuawei || isHonor) {
          return 'huawei';
      }
      if (isOppo || isOppoR15 || isRno4 || isRno3) {
          return 'oppo';
      }
      if (isVivo || isVivo3) {
          return 'vivo';
      }
      if (isXiaomi || isRedmi || isXiaomi2s) {
          return 'xiaomi';
      }
      if (isSamsung) {
          return 'samsung';
      }
      if (isMeizu || isMz || isMeizuqq || isMx || isMzNote) {
          return 'meizu';
      }
      return 'default';
  }
  function getBrowser() {
      var ua = navigator.userAgent;
      var browser = {
          name: 'unknown',
          version: 'unknown'
      };
      if (ua.includes('MicroMessenger')) {
          browser.name = 'wechat';
          browser.version = getVersion('MicroMessenger');
      }
      else if (ua.includes('QQ')) {
          browser.name = 'qq';
          browser.version = getVersion('QQ');
      }
      else if (ua.includes('ucweb') || ua.includes('UCBrowser')) {
          browser.name = 'uc';
          browser.version = 'uc';
      }
      else if (ua.includes('Safari')) {
          browser.name = 'safari';
          browser.version = getVersion('Safari');
      }
      else if (ua.includes('Chrome')) {
          browser.name = 'chrome';
          browser.version = getVersion('Chrome');
      }
      return browser;
  }
  function isWechat() {
      return getBrowser().name === 'wechat';
  }
  function isQQ() {
      return getBrowser().name === 'qq';
  }
  function isAndroid() {
      return getOS().name === 'android';
  }
  function isIos() {
      return getOS().name === 'ios';
  }
  function isOppo() {
      return judgeBrand() === 'oppo';
  }
  function isVivo() {
      return judgeBrand() === 'vivo';
  }
  function isHuawei() {
      return judgeBrand() === 'huawei';
  }
  function isXiaomi() {
      return judgeBrand() === 'xiaomi';
  }
  function isSamsung() {
      return judgeBrand() === 'samsung';
  }
  function isMeizu() {
      return judgeBrand() === 'meizu';
  }
  //获取APP版本号
  function getVersion(name) {
      var ua = navigator.userAgent;
      var reg = new RegExp(name + "/([\\w.]+)");
      if (reg.test(ua))
          return ua.match(reg)[1];
  }
  function iosVerion(num) {
      var ua = window.navigator.userAgent.toLowerCase();
      // if (ua.indexOf('like mac os x') > 0) {
      var reg = /os [\d._]*/gi;
      var verinfo = ua.match(reg);
      var version = String(verinfo)
          .replace(/[^0-9|_.]/gi, '')
          .replace(/_/gi, '.');
      // console.log('version', version)
      var arr = version.split('.');
      // console.log('arr', arr)
      var versionNum = Number(arr[0]);
      if (versionNum >= num) {
          // console.log('15')
          return true;
      }
      // console.log('15以下')
      return false;
      // }
  }
  /**
   * 版本号比较进阶版
   * ver1  前一个版本
   * ver2  后一个版本
   *  **/
  function compareVersion(ver1, ver2) {
      var v1 = ver1.split('.');
      var v2 = ver2.split('.');
      var len = Math.max(v1.length, v2.length);
      // 调整两个版本号位数相同
      while (v1.length < len) {
          v1.push('0');
      }
      while (v2.length < len) {
          v2.push('0');
      }
      // 循环判断每位数的大小
      for (var i = 0; i < len; i++) {
          var num1 = parseInt(v1[i]);
          var num2 = parseInt(v2[i]);
          if (num1 > num2) {
              //前一个版本 大于 后一个版本
              return 1;
          }
          else if (num1 < num2) {
              //前一个版本 小于 后一个版本
              return -1;
          }
      }
      return 0;
  }

  var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getOS: getOS,
    judgeBrand: judgeBrand,
    getBrowser: getBrowser,
    isWechat: isWechat,
    isQQ: isQQ,
    isAndroid: isAndroid,
    isIos: isIos,
    isOppo: isOppo,
    isVivo: isVivo,
    isHuawei: isHuawei,
    isXiaomi: isXiaomi,
    isSamsung: isSamsung,
    isMeizu: isMeizu,
    getVersion: getVersion,
    iosVerion: iosVerion,
    compareVersion: compareVersion
  });

  var SessionStore = /** @class */ (function () {
      function SessionStore() {
      }
      SessionStore.prototype.set = function (key, value) {
          window.sessionStorage.setItem(key, JSON.stringify(value));
      };
      // eslint-disable-next-line @typescript-eslint/promise-function-async
      SessionStore.prototype.get = function (key) {
          var value = window.sessionStorage.getItem(key);
          return value ? JSON.parse(value) : null;
      };
      SessionStore.prototype.remove = function (key) {
          window.sessionStorage.removeItem(key);
      };
      SessionStore.prototype.clear = function () {
          window.sessionStorage.clear();
      };
      return SessionStore;
  }());

  var LocalStore = /** @class */ (function () {
      function LocalStore() {
      }
      LocalStore.prototype.set = function (key, value, expires) {
          if (expires) {
              this.set("__expires_" + key + "__", Date.now() + expires);
          }
          window.localStorage.setItem(key, JSON.stringify(value));
      };
      // eslint-disable-next-line @typescript-eslint/promise-function-async
      LocalStore.prototype.get = function (key) {
          var expired = window.localStorage.getItem("__expires_" + key + "__");
          if (expired && JSON.parse(expired) < Date.now()) {
              this.remove(key);
              this.remove("__expires_" + key + "__");
              return null;
          }
          var value = window.localStorage.getItem(key);
          return value ? JSON.parse(value) : null;
      };
      LocalStore.prototype.remove = function (key) {
          window.localStorage.removeItem(key);
      };
      LocalStore.prototype.clear = function () {
          window.localStorage.clear();
      };
      return LocalStore;
  }());

  var sessionStore = new SessionStore();
  var localStore = new LocalStore();

  var cache = {};
  function dynamicLoad(url) {
      return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
              if (cache[url])
                  return [2 /*return*/];
              return [2 /*return*/, new Promise(function (resolve, reject) {
                      var script = document.createElement('script');
                      script.type = 'text/javascript';
                      script.src = url;
                      script.addEventListener('load', function () {
                          cache[url] = true;
                          resolve();
                      });
                      script.addEventListener('error', function (error) {
                          reject(error);
                      });
                      document.body.appendChild(script);
                  })];
          });
      });
  }

  /**
   * 根据域名切换备案号
   *
   * @export
   * @returns {ResponseICP}
   */
  function modifyICP() {
      var host = window.location.hostname;
      var obj = {
          'www.xhqb.com': {
              company: '小花网络科技（深圳）有限公司',
              icp: '粤ICP备2021018097号-1'
          },
          'www.xinxiloan.com': {
              company: '重庆信喜小额贷款有限公司',
              icp: '渝ICP备18006248号-1'
          },
          'www.dachengrd.com': {
              company: '重庆大诚融资担保有限公司',
              icp: '渝ICP备2021009587号-1'
          },
          'www.truechine.com': {
              company: '上海处成科技有限公司',
              icp: '沪ICP备2020027929号-2'
          },
          'www.truecheng.com': {
              company: '上海处成科技有限公司',
              icp: '沪ICP备2020027929号-1'
          },
          'www.kanzhonginfo.com': {
              company: '重庆看重信息科技有限公司',
              icp: '渝ICP备2021005605号-1'
          },
          'www.cqkanzhong.com': {
              company: '重庆看重信息科技有限公司',
              icp: '渝ICP备2021005605号-3'
          },
          'www.zhuyexiaowei.com': {
              company: '重庆看重信息科技有限公司',
              icp: '渝ICP备2021005605号-5'
          },
          'www.zhuyexw.com': {
              company: '重庆看重信息科技有限公司',
              icp: '渝ICP备2021005605号-4'
          },
          'www.xiaohuaai.com': {
              company: '晓花（上海）互联网科技有限公司',
              icp: '沪ICP备20014574号-5'
          },
          'www.xh0.cn': {
              company: '晓花（上海）互联网科技有限公司',
              icp: '沪ICP备20014574号-9'
          },
          'www.facash.com': {
              company: '晓花（上海）互联网科技有限公司',
              icp: '沪ICP备20014574号-7'
          },
          '0.0.0.0': {
              company: '这是测试用的本地主体',
              icp: '这是测试用的本地ICP'
          },
          '127.0.0.1': {
              company: '这是测试用的本地主体-1',
              icp: '这是测试用的本地ICP-1'
          },
          localhost: {
              company: '这是测试用的本地主体-2',
              icp: '这是测试用的本地ICP-2'
          },
          'test.xiaohuaai.com': {
              company: '这是测试用的本地主体-3',
              icp: '这是测试用的本地ICP-3'
          }
      };
      var result;
      if (Object.keys(obj).includes(host)) {
          result = obj[host];
      }
      else {
          result = {
              company: '',
              icp: ''
          };
      }
      return result;
  }

  /**
   * 跳转应用商店
   * 封装 window.location.href
   * 可选参数appChannel
   *
   * appChannel: 渠道（可选）
   * @param appChannel
   */
  function downloadApp(appChannel) {
      var ua = window.navigator.userAgent.toLowerCase();
      var match = ua.match(/MicroMessenger/i);
      if (match === null) {
          if (isAndroid()) {
              if (appChannel) {
                  location.href = "https://dl.xhqb.com/Android/prod/" + appChannel + ".apk";
                  return;
              }
              location.href = "https://dl.xhqbapp.com/Android/prod/xhqb01.apk";
          }
          else if (isIos()) {
              location.href =
                  'https://apps.apple.com/us/app/%E6%96%B0%E5%B0%8F%E8%8A%B1%E9%92%B1%E5%8C%85/id1580545905';
          }
          else {
              location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xhqb.app';
          }
      }
      else if (match.includes('micromessenger')) {
          location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xhqb.app';
      }
  }

  exports.downloadApp = downloadApp;
  exports.dynamicLoad = dynamicLoad;
  exports.formatter = index$3;
  exports.localStore = localStore;
  exports.modifyICP = modifyICP;
  exports.rule = rule;
  exports.sessionStore = sessionStore;
  exports.url = index$2;
  exports.useragent = index;
  exports.validator = index$1;

  Object.defineProperty(exports, '__esModule', { value: true });

}));



//////////////////
// WEBPACK FOOTER
// ./~/@xhtech/lux/dist/lux.umd.js
// module id = 101
// module chunks = 0 3 4 5 6 7 8 9 10 12 13 16 17 18 19 20 21 22 23 24 25 26 27 30 31 33 35 36 37 38 39 40 41 42 43 44 46 48 49 52 53 54 55 56 59 60 61 63 64 69 71 74 76 77 78 79 82 83 84 87 88 89 91 92 93 94 95 96 97 100 101 102 103 104 105 106 109 111 112 113 114 115 117 118 119 120 121 125 127 128 129 133 134 135 138 142 143 144 145 146 147 148 149 150 151 153 154 155 156 159 161 162 163 164 165 166 168 169 170 171 172 173 174